module.exports = __webpack_public_path__ + "0dcb1c97b6c85d6b95cf81f67abf49e1.svg";